import styled from 'styled-components';
import { Paper, Text, Space } from '@cashfree-intl/coherent';

export const StyledWalletPaper = styled(Paper)`
  width: 30.18rem;
`;

export const StyledWalletInfoText = styled(Text)`
  max-width: 7rem;
  text-align: right;
`;

export const StyledFeeWalletInfoText = styled(Text)`
  max-width: 10.625rem;
  text-align: right;
`;

export const StyledCursorText = styled(Text)`
  cursor: pointer;
`;

export const StyledFeeWalletLowBalanceSpace = styled(Space)`
  background-color: #f7dfdf;
  padding: 2px 6px;
  border-radius: 2px;
`;
